import { AmountSuperScript } from "components/design/AmountSuperScript";
import { Button } from "components/DesignSystem/Button/Button";
import { Link } from "components/DesignSystem/Link/Link";
import { OctagonExclamation } from "components/icons/OctagonExclamation";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { stringify } from "qs";
import { useLocation } from "react-router-dom";

export const UnpaidDues = ({ amount }: { amount: number }) => {
  const entityId = useCurrentEntityId();
  const { search, pathname } = useLocation();

  const searchQuery = stringify(
    {
      entity: entityId,
      settings_back_to: pathname + search,
    },
    { skipNulls: true, addQueryPrefix: true }
  );

  const invoicePage = `/settings/billing/invoices${searchQuery}`;

  return (
    <div className="t-flex t-items-center t-gap-1.5 t-rounded-lg t-border t-border-solid t-border-red-10 t-bg-red-0 t-px-2 t-py-2">
      <span className="t-flex t-shrink-0 t-p-0.5 t-text-red-70">
        <OctagonExclamation />
      </span>

      <p className="t-mb-0 t-flex-1 t-text-body-sm t-text-text-30">
        Invoices due: <AmountSuperScript amount={amount} />
      </p>

      <Link to={invoicePage} className="t-shrink-0">
        <Button customType="secondary" size="small">
          View all invoices
        </Button>
      </Link>
    </div>
  );
};
